import * as R from 'ramda'

export type OrderFilterType =
    | 'BpsUser'
    | 'Status'
    | 'Customer'
    | 'Company'
    | 'OrderNumber'
    | 'ShippingMethod'
    | 'CreatedFrom'
    | 'CreatedTo'
    | 'PriceFrom'
    | 'PriceTo'
    | 'OrderPaid'

export function all(): OrderFilterType[] {
    return [
        'OrderNumber',
        'BpsUser',
        'OrderPaid',
        'CreatedTo',
        'CreatedFrom',
        'Company',
        'Customer',
        'PriceTo',
        'PriceFrom',
        'Status',
        'ShippingMethod',
    ]
}

export function label(filterType: OrderFilterType): string {
    switch (filterType) {
        case 'BpsUser':
            return 'Besteller'
        case 'Status':
            return 'Status'
        case 'Customer':
            return 'Kunde'
        case 'Company':
            return 'Gesellschaft'
        case 'OrderNumber':
            return 'Auftragsnummer'
        case 'ShippingMethod':
            return 'Versand'
        case 'CreatedFrom':
            return 'Datum von'
        case 'CreatedTo':
            return 'Datum bis'
        case 'PriceFrom':
            return 'Preis von'
        case 'PriceTo':
            return 'Preis bis'
        case 'OrderPaid':
            return 'Bezahlstatus'
    }
}

export function sort(filterTypes: OrderFilterType[]): OrderFilterType[] {
    return R.sortBy(label, filterTypes)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/OrderFiltering/Model/OrderFilterType.ts